export class NotificationTokenInput {
  token: string;

}
